"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAT_CLASS_PREFIX = exports.DEFAULT_CLASS_PREFIX = exports.ConfigContext = void 0;
var _react = require("react");
var _config = require("../_utils/config");
var DEFAULT_CLASS_PREFIX = exports.DEFAULT_CLASS_PREFIX = 'tp';
var MAT_CLASS_PREFIX = exports.MAT_CLASS_PREFIX = _config.MAT_CLASS_PREFIX || '';
var ConfigContext = exports.ConfigContext = /*#__PURE__*/(0, _react.createContext)({
  classPrefix: DEFAULT_CLASS_PREFIX,
  matClassPrefix: MAT_CLASS_PREFIX
});